import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import About from '../Components/About'

export default function AboutLayout() {
  return (
    <div>
      <Navbar/>
      <About/>
      <Footer/>
    </div>
  )
}
